import * as React from 'react';

const SvgArrowSmallDown = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "m12 17.3 7-5.86V8.82l-7 5.88-7-5.88v2.62l7 5.86Z" })
);

export { SvgArrowSmallDown as default };
//# sourceMappingURL=ArrowSmallDown.es.js.map
